import FullPageLoader from 'components/common/FullPageLoader';
import LiveClock from 'components/common/LiveClock';
import AddGropus from 'components/permissionGroup/AddGroup';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { PermissionSelector } from 'slices/permissionGroupSlice';
import { fetchSinglePermission } from 'slices/permissionGroupSlice';
import { fetchPermissionGroupList } from 'slices/permissionGroupSlice';
import { templatesSelector } from 'slices/templateSlice';
import { fetchTemplatesListPage } from 'slices/templateSlice';
import { useTranslation } from 'react-i18next';

const UpdateGroup = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { singleData, loader, error } = useSelector(PermissionSelector);
    const { id } = useParams();

    useEffect(() => {
            if (id) {
                dispatch(fetchSinglePermission(id));
            }
        }, [dispatch, id]);
    
        if (!singleData) return <div>{t('groupForm.noInterpreterFound')}</div>;
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> {t('common.back')}
                    </button>
                    <h2 className="main_heading">{t('groupForm.updateTitle')}</h2>
                </div>
            </div>

            <AddGropus item={singleData} loader={loader}/>
        </div>
    );
};

export default UpdateGroup;
